/* -----------------Globals--------------- */
import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppStore } from "@hooks/useAppStore";
import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { type IconType, MemorangIcons } from "components/index";
import { Tabs } from "expo-router";
import { useTranslation } from "react-i18next";
import { Pressable } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export const AppBottomTabs = () => {
	const theme = useAppTheme();
	const appFont = useAppStore((store) => store.app.font);
	const { t } = useTranslation();

	const {
		navigation: {
			routes: { main: tabs },
		},
		showStudyPackAsHome,
	} = useAppStore((store) => ({
		navigation: store.navigation,
		showStudyPackAsHome: store.showStudyPackAsHome,
	}));
	const insets = useSafeAreaInsets();

	return (
		<Tabs
			screenOptions={{
				headerShown: false,
				tabBarActiveTintColor: theme.colors.onSecondaryContainer,
				tabBarStyle: {
					height: 80 + insets.bottom,
					borderTopWidth: 0,
					backgroundColor: theme.colors.elevation.level2,
					paddingTop: 16,
				},
				tabBarLabelStyle: {
					fontFamily: `${appFont}-regular`,
					fontSize: 12,
					paddingBottom: 16,
					color: theme.colors.text,
				},
				tabBarLabelPosition: "below-icon",
				// biome-ignore lint/suspicious/noExplicitAny: tabBarButton has third party typing mismatch
				tabBarButton: ({ ref, ...props }: any) => (
					<Pressable
						{...props}
						android_ripple={null}
						style={
							props.style as React.ComponentProps<typeof Pressable>["style"]
						}
					/>
				),
			}}
		>
			{tabs.map(({ name, icon, enabled, custom }) => {
				//TODO:Temp fix, information should come from the backend
				const isHomeTab = name === "home";
				if (isHomeTab && showStudyPackAsHome) {
					name = "home";
					icon = { default: "study-pack-outline", selected: "study-pack" };
					custom = true;
				}

				return (
					<Tabs.Screen
						key={name}
						name={name}
						options={{
							...(enabled
								? {}
								: {
										href: null,
									}),
							tabBarIcon: ({ focused, color }) => {
								const selectedIcon = icon.selected as IconType;
								const defaultIcon = icon.default as IconType;
								return (
									<Box
										width={64}
										height={34}
										borderRadius={34 / 2}
										backgroundColor={
											focused ? theme.colors.secondaryContainer : "transparent"
										}
										alignItems="center"
										justifyContent="center"
										marginBottom={12}
									>
										{custom ? (
											<MemorangIcons
												name={focused ? selectedIcon : defaultIcon}
												size={24}
												color={color}
											/>
										) : (
											<Icon
												name={focused ? selectedIcon : defaultIcon}
												size={24}
												color={color}
											/>
										)}
									</Box>
								);
							},

							tabBarLabel: t(`navbar.${name}`),
						}}
					/>
				);
			})}
			<Tabs.Screen
				name="practice-tests"
				options={{
					href: null,
				}}
			/>
			<Tabs.Screen
				name="modules"
				options={{
					href: null,
				}}
			/>
			<Tabs.Screen
				name="principles"
				options={{
					href: null,
				}}
			/>
		</Tabs>
	);
};
